<template>
  <div class="app">
    <FullSite></FullSite>
  </div>
</template>

<script>
import FullSite from "./components/FullSite.vue";

export default {
  name: "app",
  components: {
    FullSite
  }
};
</script>

<style src="./assets/styles/app.scss" lang="scss"></style>
